import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=f98c3234&scoped=true"
import script from "./vHeader.vue?vue&type=script&lang=js"
export * from "./vHeader.vue?vue&type=script&lang=js"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=f98c3234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98c3234",
  null
  
)

export default component.exports